export const createNamespaceForSimulationsFeature = (
	subNamespace: string,
): string => {
	return `features/Simulations/${subNamespace}`;
};
